<template>
  <ReviewStep>
    <ReviewSection v-if="is3rdParty"
      title="Beneficiary Information"
      @edit="goToStep('Contact Info')"
    >
      <div>
        <div>{{ formData.onBehalfOfFirstName }} {{ formData.onBehalfOfLastName }}</div>
        <div>{{ formData.onBehalfOfAddressLine1 }}</div>
        <div v-if="formData.onBehalfOfAddressLine2">{{ formData.onBehalfOfAddressLine2 }}</div>
        <div>
          {{ formData.onBehalfOfCity }}, {{ formData.onBehalfOfState }} {{ formData.onBehalfOfZip }}
        </div>
      </div>

      <div>
        <label class="form-label">Date of Birth</label>
        <div>{{ $filters.formatJsonDate(formData.onBehalfOfBirthDate) }}</div>
      </div>
      <div>
        <label class="form-label">Medicare Number</label>
        <div>{{ formData.onBehalfOfMedicareNumber }}</div>
      </div>
      <div v-if="formData.externalCaseNumber">
        <label class="form-label">Reference Number</label>
        <div>{{ formData.externalCaseNumber }}</div>
      </div>
    </ReviewSection>

    <ReviewSection title="Requestor Information"
      @edit="goToStep('Contact Info')"
    >
      <div>
        <div>{{ formData.fromFirstName }} {{ formData.fromLastName }}</div>
        <div v-if="formData.fromOrganization">{{ formData.fromOrganization }}</div>
        <div>{{ formData.fromAddressLine1 }}</div>
        <div v-if="formData.fromAddressLine2">{{ formData.fromAddressLine2 }}</div>
        <div>{{ formData.fromCity }}, {{ formData.fromState }} {{ formData.fromZip }}</div>
      </div>
      <div v-if="formData.fromEmail">
        <label class="form-label">Email</label>
        <div>{{ formData.fromEmail }}</div>
      </div>
      <div v-if="formData.fromPhone">
        <label class="form-label">Phone</label>
        <div>{{ formData.fromPhone }}</div>
      </div>
      <div v-if="formData.fromFax">
        <label class="form-label">Fax</label>
        <div>{{ formData.fromFax }}</div>
      </div>

      <template v-if="!is3rdParty">
        <div>
          <label class="form-label">Date of Birth</label>
          <div>{{ $filters.formatJsonDate(formData.fromBirthDate) }}</div>
        </div>
        <div>
          <label class="form-label">Medicare Number</label>
          <div>{{ formData.fromMedicareNumber }}</div>
        </div>
      </template>
    </ReviewSection>

    <ReviewSection title="Record Details"
      @edit="goToStep('Record Details')
    ">
      <div v-if="formData.recordDateRanges">
        <label class="form-label">Record Date Ranges</label>
        <div>{{ formData.recordDateRanges }}</div>
      </div>
      <div v-if="formData.timelineOfRelease">
        <label class="form-label">Timeline of Release</label>
        <div>{{ formData.timelineOfRelease }}</div>
      </div>

      <div v-if="formData.comments">
        <label class="form-label">Additional Comments</label>
        <div>{{ formData.comments }}</div>
      </div>
      <div v-if="formData.attachments.length">
        <div><label class="form-label">Documentation</label></div>
        <ul>
          <li v-for="{ name } in formData.attachments
              .sort((a, b) => a.name.localeCompare(b.name))
            "
            :key="name"
            class="file-name"
          >{{ name }}</li>
        </ul>
      </div>
    </ReviewSection>

    <ReviewSection title="Other Details"
      @edit="goToStep('Other Details')
    ">
      <div>
        <label class="form-label">Fee Waiver Requested</label>
        <div>{{ formData.feeWaiverRequested ? 'Yes' : 'No' }}</div>
      </div>
      <div v-if="formData.feeWaiverRequested">
        <label class="form-label">Waiver Justification</label>
        <div>{{ formData.feeWaiverJustification }}</div>
      </div>
      <div v-else>
        <label class="form-label">Max Fee Amount</label>
        <div>{{ $filters.formatCurrency(formData.maxFeeAmount) }}</div>
      </div>

      <div>
        <label class="form-label">Expedited Processing Requested</label>
        <div>{{ formData.expeditedProcessingRequested ? 'Yes' : 'No' }}</div>
      </div>
      <div v-if="formData.expeditedProcessingRequested">
        <label class="form-label">Expedition Justification</label>
        <div>{{ formData.expeditionJustification }}</div>
      </div>

      <div>
        <label class="form-label">Record Certification Requested</label>
        <div>{{ formData.recordCertificationRequested ? 'Yes' : 'No' }}</div>
      </div>

      <template v-if="formData.recordCertificationRequested">
        <div>
          <label class="form-label">U.S. Government is a Party to the Proceeding</label>
          <div>{{ formData.certificationIsNotAParty ? 'No' : 'Yes' }}</div>
        </div>
        <div>
          <label class="form-label">Civil or Criminal Case Number</label>
          <div>{{ formData.civilOrCriminalCaseNumber }}</div>
        </div>
        <div>
          <label class="form-label">Name of the Court</label>
          <div>{{ formData.nameOfTheCourt }}</div>
        </div>
      </template>
    </ReviewSection>
  </ReviewStep>
</template>

<script>
/* eslint-disable import/extensions */
import ReviewStep from '../../../../components/requestWizard/ReviewStep.vue';
import ReviewSection from '../../../../components/requestWizard/ReviewSection.vue';
import { formData, is3rdParty } from '../requestWizardState';

export default {
  setup: () => ({ formData, is3rdParty }),

  components: { ReviewSection, ReviewStep },

  methods: {
    goToStep(name) {
      this.$emit('go-to-step', name);
    }
  }
};
</script>
